import { Divider } from "@mui/material";
import { MdOutlineDeleteForever, MdOutlineMailOutline } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";
import { useEffect, useState } from "react";
import { twMerge } from "tailwind-merge";
import { get, post, Put } from "../../../services/service";
import { REPORT_SENDING_EMAILS } from "../../../services/apiUrls";
import toast, { Toaster } from "react-hot-toast";

const INPUT_CLASS = "rounded flex-1 border border-[gray]/30 p-2 outline-none";

const INITITAL_DETAILS = {
  email: "",
  scheduledTime: "06:00:00",
};

export const EmailConfig = ({handleClost}) => {
  const [details, setDetails] = useState(INITITAL_DETAILS);
  const [list, setList] = useState([]);

  const tenantId = localStorage.getItem("tenantId");
  const locationId = localStorage.getItem("locationId");

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    const url = REPORT_SENDING_EMAILS.replace("{tenantId}", tenantId).replace(
      "{locationId}",
      locationId
    );
    try {
      const resp = await get(url, { locationId, tenantId });
      setList(resp.data);
    } catch (err) {
      console.log(err);
    }
  };

  const handleChange = (e) => {
    const { value, name } = e.target;
    setDetails((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddList = async (e) => {
    e.preventDefault();
    const url = REPORT_SENDING_EMAILS.replace("{tenantId}", tenantId).replace(
      "{locationId}",
      locationId
    );
    if (details.id) {
      await Put(url, { ...details, locationId, tenantId });
    }
    setList((prev) => [...prev, details]);
    setDetails(INITITAL_DETAILS);
  };

  const addToEdit = (data, index) => {
    setDetails(data);
    deleteFromList(index);
  };

  const deleteFromList = (index) => {
    let tempList = [...list];
    tempList.splice(index, 1);
    setList(tempList);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    //REPORT_SENDING_EMAILS
    const url = REPORT_SENDING_EMAILS.replace("{tenantId}", tenantId).replace(
      "{locationId}",
      locationId
    );
    try {
      const resp = await Promise.all(
        list
          .filter((x) => x.id === undefined)
          .map((data) => post(url, { ...data, tenantId, locationId }))
      );

      toast.success("Email saved successfully");
      handleClost()
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="space-y-4 w-full relative flex flex-col">
      {/* <div className="flex ga-2 w-full">
        <div className="flex flex-col w-full">
          <span className="font-semibold">Set Schedule Time</span>
          <input
            name="scheduledTime"
            onChange={handleChange}
            value={details.scheduledTime}
            type="time"
            className={twMerge(INPUT_CLASS, "p-1.5 px-2")}
          />
        </div>
      </div> */}
      <div className="flex gap-2 items-end">
        <div className="flex flex-col w-full">
          <span className="font-semibold">Add Emails</span>
          <form onSubmit={handleAddList} className="flex gap-2">
            <input
              required
              name="email"
              placeholder="Enter you email"
              onChange={handleChange}
              value={details.email}
              className={INPUT_CLASS}
            />
            <button
              type="submit"
              className="w-[7rem] cursor-pointer rounded p-2 bg-[linear-gradient(135deg,#3A416F_0%,#141727_100%)] text-[white] disabled:bg-[gray] h-fit"
            >
              {details.id ? "Edit" : "Add"}
            </button>
          </form>
        </div>
      </div>

      <Divider />

      <div className="flex gap-3 max-h-[150px] overflow-y-auto p-2 flex-wrap">
        {list.map((data, index) => (
          <div className="rounded-[4rem] h-fit bg-[gray]/25 p-2 flex gap-2 justify-between items-center">
            <span>{data.email}</span>
            <div className="gap-3 flex items-center">
              <FaRegEdit
                onClick={() => addToEdit(data, index)}
                className="size-5 cursor-pointer"
              />
              <MdOutlineDeleteForever
                onClick={() => deleteFromList(index)}
                className="size-6 cursor-pointer"
              />
            </div>
          </div>
        ))}
      </div>

      {/* <div className="justify-end flex"> */}
      <button
        onClick={handleSubmit}
        className="w-full cursor-pointer rounded p-2 bg-[linear-gradient(135deg,#3A416F_0%,#141727_100%)] text-[white] disabled:bg-[gray] h-fit"
      >
        Save
      </button>
      {/* </div> */}
      <Toaster position="top-center"/>
    </div>
  );
};
